module.exports = __webpack_public_path__ + "6d12484bf4fa1fd1033ca977303ed22d.svg";